import { atomWithStorage } from 'jotai/utils'
export const themeType = atomWithStorage<'dark' | 'light'>('theme', 'dark')
